// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"644414a2","967":"6a107221"}[chunkId] + ".chunk.js";
};